import { render } from "./ListaConstrucaoEtapas.vue?vue&type=template&id=7085da1b"
import script from "./ListaConstrucaoEtapas.vue?vue&type=script&lang=js"
export * from "./ListaConstrucaoEtapas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__